export const NOMINATIF_LOADING = "NOMINATIF_LOADING";
export const NOMINATIF_RESET = "NOMINATIF_RESET";
export const GET_NOMINATIF = "GET_NOMINATIF";
export const GET_NOMINATIF_SUCCESS = "GET_NOMINATIF_SUCCESS";
export const GET_NOMINATIF_FAIL = "GET_NOMINATIF_FAIL";
export const DELETE_NOMINATIF = "DELETE_NOMINATIF"
export const DELETE_NOMINATIF_SUCCESS = "DELETE_NOMINATIF_SUCCESS"
export const DELETE_NOMINATIF_FAIL = "DELETE_NOMINATIF_FAIL"
export const UPDATE_NOMINATIF = "UPDATE_NOMINATIF"
export const UPDATE_NOMINATIF_SUCCESS = "UPDATE_NOMINATIF_SUCCESS"
export const UPDATE_NOMINATIF_FAIL = "UPDATE_NOMINATIF_FAIL"
export const ADD_NEW_NOMINATIF = "ADD_NEW_NOMINATIF"
export const ADD_NOMINATIF_SUCCESS = "ADD_NOMINATIF_SUCCESS"
export const ADD_NOMINATIF_FAIL = "ADD_NOMINATIF_FAIL"